import React from 'react';
import Radium from 'radium'

import logo from '../images/1C_shield_RGB_KO.png'

function Footer() {
  const date = new Date()
  return (

    <footer className="footer mt-auto pt-3" style={footerStyle}>
      <img src={logo} alt="Logo" width="96" style={{margin: 'auto'}}/>
      <p>&copy; {date.getFullYear()} College of the Holy Cross. All rights reserved.</p>
    </footer>
  )
}

const footerStyle = {
  display: 'flex',
  flexDirection: 'column',
  background: '#602d89',
  color: '#fff',
  textAlign: 'center',
  position: 'absolute',
  bottom: '0',
  width: '100%',
  height: 'auto',
  '@media (max-width: 420px)': {
    fontSize: '12px'
  },
  '@media (min-width: 421px)': {
    fontSize: '16px',
  },
}

export default Radium(Footer)
